import * as types from './actionTypes';

/* eslint-disable-next-line no-shadow */
export const login = (login, password) => ({
  type: types.LOGIN,
  login,
  password,
});
export const logout = ({ alerts } = {}) => ({
  type: types.LOGOUT,
  alerts,
});

export const loggedIn = token => ({
  type: types.LOGGED_IN,
  token,
});

export const settings = () => ({
  type: types.SETTINGS,
});

export function fetchUserInfoRequest() {
  return {
    type: types.FETCH_USERINFO_REQUEST,
  };
}

export function fetchUserInfoSuccess(data) {
  return {
    type: types.FETCH_USERINFO_SUCCESS,
    data,
  };
}

export function fetchUserInfoFail(error) {
  return {
    type: types.FETCH_USERINFO_FAIL,
    error,
  };
}

// fetch authorization info
export function fetchAuthorizationInfoRequest() {
  return {
    type: types.FETCH_AUTHORIZATION_INFO_REQUEST,
  };
}

export function fetchAuthorizationInfoSuccess({ data }) {
  return {
    type: types.FETCH_AUTHORIZATION_INFO_SUCCESS,
    data,
  };
}

export function fetchAuthorizationInfoFail({ error }) {
  return {
    type: types.FETCH_AUTHORIZATION_INFO_FAIL,
    error,
  };
}

// Regular action creators
export function fetchAuthorizationLogin({ redirectTo, ...credentials }) {
  return {
    type: types.FETCH_AUTHORIZATION_LOGIN_REQUEST,
    credentials,
    redirectTo,
  };
}

export function fetchAuthorizationLoginSuccess(data) {
  return {
    type: types.FETCH_AUTHORIZATION_LOGIN_SUCCESS,
    data,
  };
}

export function fetchAuthorizationLoginFail(error) {
  return {
    type: types.FETCH_AUTHORIZATION_LOGIN_FAIL,
    error,
  };
}

// Ask for reset password
export function postResetPassword({ login: loginUser }) {
  return {
    type: types.POST_RESET_PASSWORD_REQUEST,
    login: loginUser,
  };
}

export function postResetPasswordSuccess(data) {
  return {
    type: types.POST_RESET_PASSWORD_SUCCESS,
    data,
  };
}

export function postResetPasswordFail(error) {
  return {
    type: types.POST_RESET_PASSWORD_FAIL,
    error,
  };
}

// Change password
export function postChangePassword({ password, token }) {
  return {
    type: types.POST_CHANGE_PASSWORD_REQUEST,
    password,
    token,
  };
}

export function postChangePasswordSuccess(data) {
  return {
    type: types.POST_CHANGE_PASSWORD_SUCCESS,
    data,
  };
}

export function postChangePasswordFail(error) {
  return {
    type: types.POST_CHANGE_PASSWORD_FAIL,
    error,
  };
}
